import React, { PureComponent } from 'react';
import { Calendar, OnChangeProps } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { format } from 'date-fns';
import {
  IconButton,
  InputAdornment,
  Theme,
  createStyles,
  withStyles,
  WithStyles,
  ClickAwayListener,
} from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import MyPATTextField from './MyPATTextField';
import _ from 'lodash';

const styles = (theme: Theme) =>
  createStyles({
    marginLeft20: {
      marginLeft: 20,
    },
    calender: {
      '&>:first-child': {
        position: 'absolute',
        top: '46px',
        zIndex: 1000,
      },
      '& .rdrMonth': {
        width: '100%',
      },
      '& .rdrCalendarWrapper': {
        width: 'auto',
        boxShadow: '1px 1px 5px 3px #ddd',
      },
    },
    inputDisabled:{
      cursor:'default!important',
      backgroundColor: 'transparent',
      opacity: 1,
      color: '#333',
      paddingRight: '0!important',
    },
  });

interface Props extends WithStyles<typeof styles> {
  onChange: (item: OnChangeProps) => void;
  date?: Date | string;
  minDate?: Date | string;
  maxDate?: Date | string;
  errorText?: string;
  initiallyTouched?: boolean;
  [prop: string]: any;
  showBlank?:false;
}

interface State {
  showCalendar: boolean;
  touched: boolean;
  isCustomMargin: boolean;
}

class MyPATCalendar extends PureComponent<Props, State> {
  state: State = {
    showCalendar: false,
    isCustomMargin: false,
    touched: !_.isUndefined(this.props.initiallyTouched) ? this.props.initiallyTouched : true,
  };

  toggleShowCalendar = () => {
    this.setState((prevState) => {
      return {
        ...prevState,
        showCalendar: !prevState.showCalendar,
      };
    });
  };
  handleChange = (item: OnChangeProps) => {
    this.props.onChange(item);
    this.toggleShowCalendar();
  };
  handleTouched = () => {
    if (!this.state.touched) {
      this.setState({
        touched: true,
      });
    }
  };
  render() {
    let { date = new Date(), minDate, classes, maxDate, errorText, ...textFieldProps } = this.props;
   
    const { showCalendar, touched, isCustomMargin } = this.state;
    let displayValue = '';
    if (date) {
      date = new Date(date);
      displayValue = format(date, 'dd MMMM yyyy');
    }
    if (minDate) {
      minDate = new Date(minDate);
    }
    if (maxDate) {
      maxDate = new Date(maxDate);
    }
    const error = ((minDate && date < minDate) || (maxDate && date > maxDate)) && errorText && touched;
    return (
      <div style={{ position: 'relative'}} onClick={this.handleTouched}>
        <MyPATTextField
          error={error}
          errorText={errorText}
          value={displayValue}
          placeholder='Select date'
          endAdornment={
            <InputAdornment position='end' classes={{ positionEnd: isCustomMargin ? classes.marginLeft20 : '' }}>
              <IconButton
                aria-label='Toggle calendar'
                onClick={() => !textFieldProps.disabled && this.toggleShowCalendar()}
                tabIndex={textFieldProps.disabled?-1:0}
              >
                {/* <DateRangeIcon fontSize="large" /> */}
                <img src='/assets/svg/calendarIcon.svg' alt='calender-icon' />
              </IconButton>
            </InputAdornment>
          }
          {...textFieldProps}
          onChange={() => {
            this.toggleShowCalendar();
          }}
          disabled
          customClasses={!textFieldProps.disabled?{disabled: classes.inputDisabled}:{}}
        />
        {showCalendar && (
          <div className={classes.calender}> 
            {/* @Shivam/@Rittick: What if condition false and it will make a blank div there */}
            <ClickAwayListener onClickAway={this.toggleShowCalendar}>
              <Calendar onChange={this.handleChange} date={date} minDate={minDate} maxDate={maxDate} />
            </ClickAwayListener>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(MyPATCalendar);
